export function calcMedian(nums: number[]) {
    const sorted = [...nums].sort((a, b) => a - b);
    const half = Math.floor(sorted.length / 2);

    if (sorted.length % 2) {
        return sorted[half];
    }

    return (sorted[half - 1] + sorted[half]) / 2;
}
